export default __webpack_public_path__ + "static/media/icon-check-white.6cfab472.svg";